// @flow

import { stopSubmit } from 'redux-form'
import { call, fork, put, take } from 'redux-saga/effects'
import { cloneDeep } from 'lodash'
import config from 'src/config'
import { trimObjectStringValues } from 'src/helpers/formatHelpers'
import { EDIT_DIVISION, editDivision } from 'src/redux/actions/divisions/divisions'
import http from 'src/services/http'
import { history } from 'src/services/history'
// types
import type { IOEffect } from 'redux-saga/effects'

const shapeToNumber = (val: string) => {
  return +val
}

const toNumberValues = ['season_id', 'min', 'max', 'league_id']

function * watchEditDivision(): Generator<IOEffect, void, any> {
  while (true) {
    const {
      payload: { redirectCb, ...values },
    } = yield take(EDIT_DIVISION.REQUEST)
    const formId = config.editDivisionForm.id

    const formValues = cloneDeep(values)

    trimObjectStringValues(formValues)

    toNumberValues.forEach(item => {
      formValues[item] = shapeToNumber(formValues[item])
    })

    const { division_id } = formValues

    delete formValues.has_boys
    delete formValues.has_coed
    delete formValues.has_girls

    try {
      yield call(http, `api/division/${division_id}`, {
        body: JSON.stringify({
          ...formValues,
        }),
        method: 'PUT',
      })

      yield put(editDivision.success(values))
      yield call(history.push, `/my-leagues/${values.league_id}/league-management`)
    } catch (e) {
      yield put(editDivision.error(e.message))
      yield put(stopSubmit(formId, e.errors ? e.errors : {}))
    }
  }
}

export default [fork(watchEditDivision)]
